import {createFileRoute} from "@tanstack/react-router";
import {parseCollectionsListViewMode} from "~/utilities/ottokart/collectionListViewSwitcher";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/collections/$collectionId/")({
    loader: () => {},
    validateSearch: (search: Record<string, unknown>) => ({
        view: parseCollectionsListViewMode(search.view),
    }),
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
